<template>
  <div class="alert" :class="{ 'alert--text-bold': textBold }">
    <v-icon size="22">
      mdi-exclamation-thick
    </v-icon>
    <span>{{ $t("message.posts.planning.info", [type]) }}</span>
  </div>
</template>

<script>
export default {
  name: "PostFacilitiesAlert",
  props: {
    textBold: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.alert {
  color: $text;
  display: flex;
  align-items: center;

  &--text-bold {
    font-weight: bold;
  }

  ::v-deep .v-icon {
    color: $text;
  }

  span {
    @include font-size(12px);
    line-height: 1rem;
  }
}
</style>
